module.exports = __webpack_public_path__ + "static/img/8-16.3c55d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/8-16.png
// module id = 7y5p
// module chunks = 1